export default "__VITE_ASSET__88PEiN2f__"